import styled from "styled-components";
import { Form } from "antd";

export const FormItem = styled(Form.Item)`
  width: calc(48%);
  ${({ ischeckbox = false }) => !ischeckbox && `
    background-color: #eee;
    border-radius: 5px !important;
    padding: 0.25rem 0.5rem !important;
    margin: 0.5rem 0 !important;

    div,*, *:active, *:focus {
      border: none !important;
      background-color: transparent !important;
      padding: 0 !important;
    }

    .ant-col.ant-form-item-label {
      padding: 0 !important;
    }

    label {
      padding: 0 !important;
      font-weight: 500 !important;
      font-size: smaller !important;
    }

    span {
      padding: 0 0.25rem !important;
    }

    input,select {
      padding: 0 !important;
      margin: 0 !important;
      font: 400 18px Roboto, sans-serif !important;
      font-style: normal;
      width: calc(100% - 1rem) !important;
      background-color: transparent !important;
      border: none !important;
      border-radius: 0 !important;
      border-bottom: 2px solid #ccc !important;
    }

  `}
  ${({ ischeckbox = false }) => ischeckbox && `
    align-self: self-end;
    /* span {
      font: 400 18px Roboto, sans-serif !important;
    } */
  `}
`;